module.exports = __webpack_public_path__ + "img/FR28570.f3582c5f.png";